import { Center, Menu } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { CustomNavLinkComponent } from "@/components/Navbar/NavbarIconListItem";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import Icon from "@/utils/icons";

interface TermsMenuProps {
  variant?: "standalone" | "submenu";
}
export const TermsMenu = ({ variant = "standalone" }: TermsMenuProps) => {
  const { t } = useTranslation();

  const menuItems = (
    <>
      <Menu.Item
        variant="subtle"
        color={SYSTEM_COLORS.default}
        component="a"
        href="https://www.waku-robotics.com/en/terms"
        target="_blank"
      >
        {t("onboarding.tos")}
      </Menu.Item>
      <Menu.Item variant="subtle" color={SYSTEM_COLORS.default} component={Link} to="/privacy">
        {t("onboarding.pp")}
      </Menu.Item>
      <Menu.Item variant="subtle" color={SYSTEM_COLORS.default} component={Link} to="/terms-trial">
        {t("onboarding.tos-trial")}
      </Menu.Item>
    </>
  );

  if (variant === "submenu") {
    return (
      <Menu.Sub>
        <Menu.Sub.Target>
          <Menu.Sub.Item leftSection={<Icon.LEGAL />}>{t("onboarding.tos")}</Menu.Sub.Item>
        </Menu.Sub.Target>

        <Menu.Sub.Dropdown>{menuItems}</Menu.Sub.Dropdown>
      </Menu.Sub>
    );
  }

  return (
    <Menu trigger="click-hover">
      <Menu.Target>
        <Center>
          <CustomNavLinkComponent>
            <Icon.LEGAL />
          </CustomNavLinkComponent>
        </Center>
      </Menu.Target>

      <Menu.Dropdown>{menuItems}</Menu.Dropdown>
    </Menu>
  );
};

export default TermsMenu;
